(function () {
  if (customElements.get('planlama-slider')) return;

  class PlanlamaSlider extends HTMLElement {
    connectedCallback() {
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', this.init.bind(this), { once: true });
        return;
      }
      this.init();
    }

    init() {
      if (typeof Swiper === 'undefined' || this.swiper) return;

      var track = this.querySelector('.planlama-slider__track');
      if (!track) return;

      var settings = {};
      try {
        settings = JSON.parse(this.dataset.settings || '{}');
      } catch (e) {
        settings = {};
      }

      var options = {
        speed: 700,
        loop: !!settings.loop,
        grabCursor: true,
        keyboard: { enabled: true },
        a11y: { enabled: true },
        // Shopify's block-rendering API wraps each block in its own
        // <div class="shopify-block"> (needed for editor selection), which
        // puts our .swiper-slide one level deeper than a direct child of
        // .swiper-wrapper. Point Swiper at that wrapper instead so slide
        // detection/looping works; visual slide styling is handled in
        // section-3d-planning-slider.css.
        slideClass: 'shopify-block',
      };

      if (settings.showPagination) {
        options.pagination = {
          el: this.querySelector('.planlama-slider__pagination'),
          clickable: true,
          type: 'bullets',
        };
      }

      if (settings.autoplay) {
        options.autoplay = {
          delay: settings.autoplaySpeed || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.swiper = new Swiper(track, options);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('planlama-slider', PlanlamaSlider);
})();
